export default "__VITE_ASSET__D0Lf8JhM__"